import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import { initStorage } from "@/lib/storage";
import { isLoggedIn } from "@/lib/auth";
import Login from "@/pages/Login";
import Ringkasan from "@/pages/Ringkasan";
import KompasBuku from "@/pages/KompasBuku";
import ProgresMembaca from "@/pages/ProgresMembaca";
import BedahArgumen from "@/pages/BedahArgumen";
import CatatanSaya from "@/pages/CatatanSaya";
import TokoBuku from "@/pages/TokoBuku";
import Keranjang from "@/pages/Keranjang";
import Langganan from "@/pages/Langganan";
import Pengaturan from "@/pages/Pengaturan";

initStorage();

function Protected({ children }) {
  const loc = useLocation();
  return isLoggedIn() ? children : <Navigate to="/masuk" replace state={{ from: loc.pathname }} />;
}

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollTop />
        <Routes>
          <Route path="/masuk" element={isLoggedIn() ? <Navigate to="/ringkasan" replace /> : <Login />} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/ringkasan" element={<Ringkasan />} />
            <Route path="/kompas-buku" element={<KompasBuku />} />
            <Route path="/progres-membaca" element={<ProgresMembaca />} />
            <Route path="/bedah-argumen" element={<BedahArgumen />} />
            <Route path="/catatan" element={<CatatanSaya />} />
            <Route path="/toko-buku" element={<TokoBuku />} />
            <Route path="/keranjang" element={<Keranjang />} />
            <Route path="/langganan" element={<Langganan />} />
            <Route path="/pengaturan" element={<Pengaturan />} />
          </Route>
          <Route path="*" element={<Navigate to="/ringkasan" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}
